import { ThemeProvider } from "@mui/material";
import { useCurrentTheme } from "../theme/theme";
import AppRouter from "./AppRouter";

/**
 * App defines all client routes of GreenRouter UI application.
 *
 * @returns the App component
 */
const App = () => {
	const { theme } = useCurrentTheme();

	return (
		<ThemeProvider theme={theme}>
			<AppRouter />
		</ThemeProvider>
	);
};

export default App;
